<template>
  <div class="animated fadeIn">
    <div class="contacts__map">
      <div class="map">
        <div class="map__header">
          <div class="map__header-item medium" v-if="regions">
            <div class="select__label">Region</div>
            <v-select class="select multiple clear flexible" multiple :options="regions" @input="selectHandler" placeholder="Choose please a region">
              <template v-slot:option="option">
                <div class="checkbox select">
                  <div class="checkbox__input" :class="selectedRegions.indexOf(option.label) >= 0 && 'active'">
                    <i class="fa fa-check"></i>
                  </div>
                </div>
                {{ option.label }}
              </template>
            </v-select>
          </div>
          <div class="map__header-item">
            <div class="date-picker__label">
              Date From
            </div>
            <Datepicker
              class="date-picker"
              @selected="value => datePickerHandler('start', value)"
              :value="datePicker.startDate"
              :clearButton="true"
            />
          </div>
          <div class="map__header-item">
            <div class="date-picker__label">
              Date To
            </div>
            <Datepicker
              class="date-picker"
              @selected="value => datePickerHandler('end', value)"
              :value="datePicker.endtDate"
              :clearButton="true"
            />
          </div>
          <div class="map__header-item medium">
            <div class="select__label">Visits / Leads</div>
            <v-select class="select flexible" :options="select" :value="leadsOption" @input="leadsHandler"/>
          </div>
        </div>
        <div class="map__view" v-if="markers">
          <Map
              :points="markers"
              :lat="34.003985"
              :lng="-118.109497"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import { mapGetters } from 'vuex'
  import { formatDate } from "../../shared/utils";
  import Map from './Map.vue'

  export default {
    name: 'HeatMap',
    components: {
      Datepicker,
      Map
    },
    data() {
      return {
        leadsOption: 'Visits',
        select: [
          'Visits',
          'Leads'
        ],
        selectedRegions: [],
        datePicker: {
          startDate: null,
          endDate: null,
        },
        markers: [],
      };
    },
    mounted() {
      if (!this.isRegionsLoaded) {
        this.getRegions();
      }
      this.getData();
    },
    computed: {
      ...mapGetters([
        'regions',
        'isRegionsLoaded'
      ])
    },
    methods: {
      async getRegions() {
        const endpoint = `/regions?agg=region`;
        try {
          const res = await this.$newpetehealthapi.get(endpoint);
          const regions = res.data.filter(item => {
            item.label = item.name;
            if (item.name) {
              return item;
            }
          });

          this.$store.commit('setRegions', regions);
        } catch (e) {
          return null;
        }
      },

      async getData() {
        this.markers = null;
        const baseURL = process.env.VUE_APP_RUBY_URL  + '/api/heatmap';
        const params = {};

        if (this.selectedRegions.length > 0) {
          params.region = this.selectedRegions.toString()
        }

        if (this.datePicker.startDate) {
          params.from = formatDate(this.datePicker.startDate);
        }

        if (this.datePicker.endtDate) {
          params.to = formatDate(this.datePicker.endtDate);
        }

        if (this.leadsOption === 'Leads') {
          params.leads = true;
        }

        try {
          const res = await this.$newpetehealthapi.get(baseURL, { params });
          const arr = [];
          res.data.map(item => {
            arr.push({
              lng: +item.lon,
              lat: +item.lat,
              weight: item.count,
            });
          });
          this.markers = arr;
        } catch (e) {
          console.log(e);
        }
      },

      selectHandler(e) {
        const data = [];
        e.map(item => {
          data.push(item.label);
        });

        this.selectedRegions = data;
        this.getData();
      },

      leadsHandler(e) {
        this.leadsOption = e;
        this.getData();
      },

      datePickerHandler(e, date) {
        if (e === 'start') {
          this.datePicker.startDate = date;
        } else {
          this.datePicker.endtDate = date;
        }

        this.getData();
      },
    }
  };
</script>
